import moment from "moment";
import DatePicker from "react-datepicker";
import { useParams } from "react-router";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dashboardAction, submitAction } from "../../../redux/action";
import { validateBookingEnquiry } from "../../../constant/validation";
import { onlyNumber } from "../../../constant/utils";
import UploadFilePreview from "../../UploadFilePreview/UploadFilePreview";
import { useHistory } from "react-router";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Recaptcha from "../../ReCaptcha";

const initialValue = {
  Name: "",
  Mobile: "",
  CityId: "",
  Email: "",
  Message: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha:""
};
const BookingEnquiry = (props: any) => {
  const { t } = useTranslation();
  const { centerId } = props;
  const { slug } = useParams<any>();
  const dispatch = useDispatch();
  const history = useHistory();
  const datepickerRef = useRef(null);
  const [file, setFile] = useState<any[]>([]);
  const [filePath, setFilePath] = useState<any>("");
  const [fileErr, setFileErr] = useState("");
  const cityData = useSelector((state: any) => state.dashboard.cityAll);
  const uploadData = useSelector((state: any) => (state.submit.uploadAttachment ? state.submit.uploadAttachment : {}));

  useEffect(() => {
    setFile([]);
    setFilePath("");
    dispatch(submitAction.blankAttachmentAction({}));
    return () => {
      dispatch(submitAction.blankAttachmentAction({}));
      setFile([]);
      setFilePath("");
    };
  }, []);

  const handleImgChange = (event: any) => {
    let file = event.target.files[0];
    if (!file) {
      /* setFileErr("file upload is required."); */
    } else if (
      ![
        "application/pdf",
        "image/png",
        "image/jpg",
        "image/jpeg",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ].includes(file?.type)
    ) {
      setFileErr("Document should be in .doc/.docx/.png/.pdf/.jpg/.jpeg format.");
    } else if (file?.size > 1024 * 1024 * 2) {
      setFileErr("Document size should be less than 2MB.");
    } else {
      setFileErr("");
      const formData: any = new FormData();
      formData.append("AttachmentFile", file);
      formData.append("AttachmentAction", "prescriptions");
      dispatch(submitAction.uploadAttachmentAction(formData));
    }
  };
  useEffect(() => {
    if (uploadData?.AttachmentFileName) {
      let fArr = [...file];
      fArr.push(uploadData?.AttachmentFileName);
      setFile(fArr);
      setFilePath(uploadData?.AttachmentPath);
    }
    return () => {};
  }, [uploadData?.AttachmentFileName]);

  const RemoveImg = (img: any) => {
    let arr = [...file];
    const index = arr.indexOf(img);
    if (index > -1) {
      arr.splice(index, 1);
      setFile(arr);
    }
  };

  const handleSubmit = (values: any) => {
    if (centerId) {
      let data: any = { ...values };
      data.DOB = data.DOB && moment(data?.DOB).format("YYYY-MM-DD");
      /* if (file?.length > 0) { */
      data.UploadedPrescriptions = file;
      data.CentreId = centerId;
      data.SourceUrl = window.location.href;
      const urlParams = new URLSearchParams(window.location.search);
      data.UtmSource = urlParams.get("utm_source");
      data.UtmMedium = urlParams.get("utm_medium");
      data.UtmCampaign = urlParams.get("utm_campaign");
      dispatch(submitAction.bookingEnquiryAction(data, history, slug));
      setFile([]);
      setFilePath("");
      /* } */
    }
  };
  function handleClickDatepickerIcon() {
    const datepickerElement: any = datepickerRef?.current;
    datepickerElement?.setFocus(true);
  }
  return (
    /*  <div className="h-services" style={{marginTop: "0px"}}> */
    <div className="bg_lab col-md-12 p-4 mb-4 infobox_wrapper small_form">
      <h5 className="mr-10">{t("booking_enquiry")}</h5>
      <Formik
        initialValues={initialValue}
        enableReinitialize={true}
        validationSchema={validateBookingEnquiry}
        onSubmit={(val: any) => {
          handleSubmit(val);
        }}
        render={({ values, handleChange, errors, touched, handleBlur, handleSubmit, setFieldValue }:any) => (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="Name"
                className="form-control"
                placeholder={t("name")}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values?.Name}
              />
              {touched?.Name && errors?.Name && <span className="error_message">{t(errors?.Name)}</span>}
            </div>
            <div className="form-group">
              <input
                type="text"
                name="Mobile"
                className="form-control"
                placeholder={t("mobile_number")}
                onKeyPress={onlyNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values?.Mobile}
              />
              {touched?.Mobile && errors?.Mobile && <span className="error_message">{t(errors?.Mobile)}</span>}
            </div>
            <div className="form-group">
              <select
                className="form-control"
                name="CityId"
                id="CityId"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values?.CityId}
              >
                <option value="">{t("city-with*")}</option>
                {cityData &&
                  cityData.length > 0 &&
                  cityData?.map((item: any, i: any) => (
                    <option value={item?.Id} key={i} className="text-uppercase">
                      {t(item?.Name)}
                    </option>
                  ))}
              </select>
              {touched?.CityId && errors?.CityId && <span className="error_message">{t(errors?.CityId)}</span>}
            </div>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("email")}
                name="Email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values?.Email}
              />
              {/* {touched?.Email && errors?.Email &&<span className="error_message">{t(errors?.Email)}</span>} */}
            </div>
            <div className="form-group">
              <textarea
                className="form-control"
                placeholder={t("message")}
                name="Message"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values?.Message}
              ></textarea>
            </div>
            <div className="d-flex mt-4 for-check-style">
              <input
                type="checkbox"
                name="Checkbox"
                checked={values?.Checkbox}
                onChange={handleChange}
                onBlur={handleBlur}
                id="checkbox_id"
              />
              <label className="mx-2" htmlFor="checkbox_id">
                By clicking you accept to the{" "}
                <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                  terms and conditions
                </a>{" "}
                and the{" "}
                <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                  Privacy Policy.
                </a>
              </label>
            </div>
            <div>
              {touched?.Checkbox && errors?.Checkbox && <span className="error_message">{errors?.Checkbox}</span>}
            </div>
            <div className="form-group">
              <Recaptcha
                touch={touched?.GRecaptcha}
                error={errors?.GRecaptcha}
                onChange={(token: any) => setFieldValue("GRecaptcha", token)}
                onExpired={()=> setFieldValue("GRecaptcha", "")}
              />
            </div>
            <button
              type="submit"
              className="book--hexagon active sm_form" /* onClick={() => { file?.length == 0 && setFileErr("file upload is required.") }} */
            >
              <span>
                {t("submit_btn")}
                <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
              </span>
            </button>
          </form>
        )}
      />
    </div>
    /* /</div> */
  );
};

export default BookingEnquiry;
